import { render, staticRenderFns } from "./ViewCounter.vue?vue&type=template&id=3a89b79c&scoped=true"
import script from "./ViewCounter.vue?vue&type=script&lang=js"
export * from "./ViewCounter.vue?vue&type=script&lang=js"
import style0 from "./ViewCounter.vue?vue&type=style&index=0&id=3a89b79c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a89b79c",
  null
  
)

export default component.exports